import React from 'react';
import { css } from 'aphrodite';
import styles from './reset-password-styles';
import { FilledGreenButton } from '../common';
import { FaEnvelope, FaCheckCircle } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const ResetPasswordView = (props) => (
  <div className={css(styles.root)}>
    <img src={require('../../assets/kiffgo/logo-green.svg')} className={css(styles.logo)} />
    {!props.emailSentStatus && <h1 className={css(styles.title)}>
      Reset Password
    </h1>}

    {!props.emailSentStatus && <div className={css(styles.description)}>
      Forgot your password? Enter your email address and we'll email you a link you can use to reset your password
    </div>}


    {!props.emailSentStatus && <div className={css(styles.content)}>
      <div style={{ position: 'relative' }}>
        <div className={css(styles.inputIconContainer)}><FaEnvelope className={css(styles.inputIcon)} /></div>
        <input placeholder={'Email'} type={'email'} className={css(styles.input)} value={props.email} onChange={props.onChangeEmail} onKeyDown={props.handleKeyDown} />
      </div>

      <FilledGreenButton disabled={props.disabled} title={'Reset Password'} onClick={props.resetPassword} loading={props.loading} />

    </div>}

    {props.emailSentStatus && <div className={css(styles.content)}>

      <div className={css(styles.tickWrapper)}>
        <FaCheckCircle className={css(styles.tickIcon)} />
      </div>
      <h4 className={css(styles.innerTitle)}>
        Reset code emailed.
    </h4>
      <div className={css(styles.description)}>
        Please check your email for instructions on how to reset your password.

      </div>

    </div>}


  </div>
);

export default ResetPasswordView;



// WEBPACK FOOTER //
// ./src/components/reset-password/reset-password-view.js